var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`content-section ${_vm.classes} ${_vm.no_margin ? '' : 'content-section--with-panel'} ${_vm.no_content_padding ? 'content-section--without-content-padding' : ''}`,attrs:{"compact":""}},[(_vm.title)?_c('div',{class:{
      'content-section__header': true,
      'content-section__header--without-content-padding': _vm.no_content_padding,
    }},[(_vm.icon)?_c('vb-icon',{attrs:{"name":_vm.icon,"size":20}}):_vm._e(),_c('span',{staticClass:"content-section__title",domProps:{"innerHTML":_vm._s(_vm.title)}})],1):_vm._e(),(_vm.description)?_c('p',{class:{
      'content-section__description': true,
      'content-section__description--without-content-padding':
        _vm.no_content_padding,
    },domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }